'use strict';

// Parser de-angularized and testable in /app/babel/resources/parsers/mailTemplate.js
angular.module('upResources').service('ParseMailTemplate', function () {
	return window.parseMailTemplate;
});
